export default __webpack_public_path__ + "static/media/closeIcon.e1bba694.svg";